import { render, staticRenderFns } from "./TestPagination.vue?vue&type=template&id=5d90a394&"
import script from "./TestPagination.vue?vue&type=script&lang=js&"
export * from "./TestPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports